import React from 'react';

const ProductSkeleton = () => {
  return (
    <div className="col-6 col-sm-6 col-md-3 col-lg-3 mb-2">
      <div className="card h-100 shadow-sm border-0 skeleton-card" style={{ padding: '8px' }}>
        <div className="skeleton-img mb-2"></div>
        <div className="card-body p-1 d-flex flex-column">
          <div className="skeleton-line price-line mb-1"></div>
          <div className="skeleton-line chips-line mb-2"></div>
          <div className="skeleton-line title-line mb-1"></div>
          <div className="skeleton-line title-line mb-2 w-75"></div>
          <div className="mt-auto d-flex justify-content-between align-items-center">
            <div className="skeleton-btn"></div>
            <div className="skeleton-btn"></div>
          </div>
        </div>
      </div>
      <style>{`
        .skeleton-card {
          background: #fff;
          overflow: hidden;
        }
        
        .skeleton-img {
          height: 100px;
          background: #f0f0f0;
          border-radius: 8px;
          position: relative;
        }
        
        .skeleton-line {
          height: 10px;
          background: #f0f0f0;
          border-radius: 4px;
          position: relative;
        }
        
        .price-line { width: 60%; height: 14px; }
        .chips-line { width: 100%; height: 20px; }
        .title-line { width: 100%; }
        
        .skeleton-btn {
          height: 28px;
          width: 45%;
          background: #f0f0f0;
          border-radius: 6px;
        }
        
        .skeleton-img::after,
        .skeleton-line::after,
        .skeleton-btn::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
          animation: shimmer 1.5s infinite;
        }
        
        @keyframes shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
      `}</style>
    </div>
  );
};

export default ProductSkeleton;
